import { NotBillableReason } from "@/types/__generated__/union-types"

export const DEFAULT_NOT_BILLABLE_REASON: NotBillableReason = "ADMINISTRATIVE"

export const EMPLOYER_INSURANCE = "employer" // client select option ID
